"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactResizable = require("react-resizable");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["onResize", "width", "resizable"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ColumnResizable = exports.default = /*#__PURE__*/function (_React$Component) {
  function ColumnResizable() {
    var _this;
    (0, _classCallCheck2.default)(this, ColumnResizable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ColumnResizable, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      isActiveResize: false
    });
    (0, _defineProperty2.default)(_this, "handleClick", function (e) {
      if (!_this.state.isActiveResize && _this.resizeHandleRef.current && e.target.contains(_this.resizeHandleRef.current)) {
        e.stopPropagation();
        return;
      }
      _this.props.onClick && _this.props.onClick(e);
    });
    (0, _defineProperty2.default)(_this, "handleCreateResize", function (handleAxis, ref) {
      _this.resizeHandleRef = ref;
      return /*#__PURE__*/_react.default.createElement("span", {
        onClick: _this.handleClick,
        className: "react-resizable-handle react-resizable-handle-".concat(handleAxis),
        ref: ref
      });
    });
    (0, _defineProperty2.default)(_this, "onResizeStart", function () {
      _this.setState({
        isActiveResize: true
      });
    });
    (0, _defineProperty2.default)(_this, "onResizeStop", function () {
      _this.setState({
        isActiveResize: false
      });
    });
    return _this;
  }
  (0, _inherits2.default)(ColumnResizable, _React$Component);
  return (0, _createClass2.default)(ColumnResizable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onResize = _this$props.onResize,
        width = _this$props.width,
        resizable = _this$props.resizable,
        restProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      if (!width || !resizable) {
        return /*#__PURE__*/_react.default.createElement("th", restProps);
      }
      return /*#__PURE__*/_react.default.createElement(_reactResizable.Resizable, {
        width: width,
        height: 0,
        handle: this.handleCreateResize,
        onResize: onResize,
        onResizeStart: this.onResizeStart,
        onResizeStop: this.onResizeStop
        // Filtreleme butonuna tıklanmasını engellediği için 2px'e düşürüldü.
        ,
        handleSize: [2, 10]
      }, /*#__PURE__*/_react.default.createElement("th", (0, _extends2.default)({}, restProps, {
        onClick: this.handleClick
      })));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(ColumnResizable, "propTypes", {
  width: _propTypes.default.number,
  onResize: _propTypes.default.func,
  resizable: _propTypes.default.bool
});
(0, _defineProperty2.default)(ColumnResizable, "defaultProps", {
  width: 0,
  resizable: false,
  onResize: function onResize() {}
});